import { Skeleton } from '@iheartjane/reefer';

import { ProductsSkeleton } from '@jane/bloom/components/skeletonLoaders/productsSkeleton';

import styles from './categoryPageSkeleton.module.css';

export function CategoryPageSkeleton() {
  return (
    <main className={styles['mainCategory']} data-testid="category-skeleton">
      <Skeleton animate className={styles['rowHeader']}>
        <Skeleton animate>
          <Skeleton.Bone className={styles['title']} />
          <Skeleton.Bone className={styles['productCount']} />
        </Skeleton>
        <Skeleton.Bone className={styles['mobileFilters']} />
      </Skeleton>

      <ProductsSkeleton count={10} />
    </main>
  );
}
